import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';

import { defaults } from 'ol/control'
import {fromLonLat} from 'ol/proj';


export default props => {
    return new Map({
        target: 'map',
        layers: [
          new TileLayer({
            source: new XYZ({
              url: 'http://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}',
            })
          })
        ],
        view: new View({
          center: fromLonLat([props.lon, props.lat]),
          zoom: 14
        }),
        controls: defaults({
            attribution: false,
            zoom: false,
            rotate: false
        })
    })
}